import React, { useEffect } from "react";

const ImageBoardWidget = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://widget.rss.app/v1/imageboard.js";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <rssapp-imageboard id="C2EwV4Q3Km1F7XEN"></rssapp-imageboard>;
};

export default ImageBoardWidget;
